import { useState, useCallback } from 'react';
import { apiService } from '../services/api.ts';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { isAuthSessionExpiredError } from '../services/authService.tsx';

export const useUser = (token, userId) => {
  const { t } = useTranslation();
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    instagram: '',
    linkedin: '',
    facebook: '',
    twitter: ''
  });
  const [username, setUsername] = useState('');

  const fetchUserDetails = useCallback(async () => {
    if (!token || !userId) return;
    
    try {
      const response = await apiService.getUser(token, userId);
      setUser({
        userName: response.username,
        firstName: response.firstName,
        lastName: response.lastName,
        jobTitle: response.jobTitle,
        companyName: response.companyName,
        address: response.address,
        city: response.city,
        email: response.email,
        phone: response.phone,
        instagram: response.instagram,
        linkedin: response.linkedin,
        facebook: response.facebook,
        twitter: response.twitter
      });
      setUsername(response.username);
    } catch (error) {
      if (isAuthSessionExpiredError(error)) return;
      toast.error(t('error_fetching_user_details'), { position: "bottom-left" });
    }
  }, [token, userId, t]);

  return {
    user,
    username,
    fetchUserDetails
  };
};
